/**
 * Directive: kbDraggable
 */
angular.module('acme.common.directive.kbDraggable', [])
.directive('kbDraggable', ['$parse', '$timeout', function($parse, $timeout) {

    return {
      restrict: 'A',
      scope: {
        model: '=kbDraggable',
        position: '=drag',
        onKeyPress: '&uiOnDrop'
      },

      link: function($scope, $element, $attrs) {

        var init = function() {
          bindElement();
        };

        var bindElement = function() {

          $element.find('[data-kb-up]').on('click keypress', function(event) {
            event.preventDefault();
            var newPosition = 0;
            if (
              event.type === 'click' ||
              event.keyCode === 32 // space
            ) {

              if ($scope.position !== 0) {
                newPosition = $scope.position - 1;
              } else {
                newPosition = $scope.model.length - 1;
              }

              $timeout(function() {
                $scope.onKeyPress({
                  order: newPosition,
                  $data: $scope.position
                });
              }, 0);

            }
          });

          $element.find('[data-kb-down]').on('click keypress', function(event) {
            event.preventDefault();
            var newPosition = 0;
            if (
              event.type === 'click' ||
              event.keyCode === 32 // space
            ) {

              newPosition = $scope.position + 1;
              if (newPosition >= $scope.model.length) {
                newPosition = 0;
              }

              $timeout(function() {
                $scope.onKeyPress({
                  order: newPosition,
                  $data: $scope.position
                });
              }, 0);

            }
          });
        };

        init();
      },

      controller: ['$scope', function($scope) {}]

    };

}]);
